require('./collegeCommitmentsController');

"use strict";

angular.module('app.collegeCommitments.collegeCommitmentsDirective', [
    'app.collegeCommitments.collegeCommitmentsController',
])
    .directive('collegeCommitments', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/collegeCommitments/collegeCommitmentsView.html',
                controller: 'app.collegeCommitments.collegeCommitmentsController'
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/collegeCommitments/collegeCommitmentsDirective.js